import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import {
  MatLegacyPaginator as MatPaginator,
  LegacyPageEvent as PageEvent,
} from '@angular/material/legacy-paginator';
import { ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import { SubSink } from 'subsink';

import { OrderListActions } from '@app/order-list/store/order-list.slice';
import { AuthenticationSelectors } from '@authentication/store/authentication.slice';
import { MerchantSelectors } from '@merchant/store/merchant.slice';
import { ProductSearchResponseWithAmount } from '@search/interfaces/product-search-response-with-amount.interface';
import { SearchRequest } from '@search/interfaces/search-request.intarface';
import {
  ProductSearchActions,
  ProductSearchSelectors,
} from '@search/store/search.slice';
import { paginatorConfiguration } from '@shared/constants/paginator-configuration';

@Component({
  selector: 'app-results-container',
  templateUrl: './results-container.component.html',
  styleUrls: ['./results-container.component.scss'],
})
export class ResultsContainerComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  resultIsLoading$: Observable<boolean> = this.store.select(
    ProductSearchSelectors.selectSearchedItemsLoading
  );

  totalSearchedItems$: Observable<number> = this.store.select(
    ProductSearchSelectors.selectTotalSearchedItems
  );

  searchedItems$: Observable<Array<ProductSearchResponseWithAmount>> =
    this.store.select(ProductSearchSelectors.selectSearchedItems);

  requiredMerchantDataFilled$ = this.store.select(
    MerchantSelectors.selectRequiredMerchantDataFilled
  );

  isSidenavOpen$ = this.store.select(
    ProductSearchSelectors.selectIsSidenavOpen
  );

  isSortiment$ = this.route.queryParams.pipe(
    map((params) => !!params['sortiment'])
  );

  pageSize = paginatorConfiguration.searchPageSizeOptions[0];
  pageSizeOptions = paginatorConfiguration.searchPageSizeOptions;

  searchValue: SearchRequest = {};

  selectedSiteId?: string;
  selectedMerchantType?: string;

  private subs = new SubSink();

  constructor(private store: Store, private route: ActivatedRoute) {}

  ngOnInit() {
    this.subs.sink = this.store
      .select(ProductSearchSelectors.selectSearchValue)
      .subscribe((value) => {
        this.searchValue = value;
      });

    this.subs.sink = this.store
      .select(AuthenticationSelectors.selectUserInfo)
      .subscribe((userInfo) => {
        if (!this.selectedSiteId || !this.selectedMerchantType) {
          this.selectedSiteId = userInfo.attributes?.['custom:selectedSiteId'];
          this.selectedMerchantType =
            userInfo.attributes?.['custom:selectedMerchantType'];

          if (this.selectedSiteId && this.selectedMerchantType) {
            this.store.dispatch(ProductSearchActions.searchProducts.trigger());
          }
          this.store.dispatch(
            OrderListActions.loadOrderList.trigger({
              filter: { page: 0, size: 9999 },
            })
          );
        }
        if (
          this.selectedSiteId !==
            userInfo.attributes?.['custom:selectedSiteId'] ||
          this.selectedMerchantType !==
            userInfo.attributes?.['custom:selectedMerchantType']
        ) {
          this.selectedSiteId = userInfo.attributes?.['custom:selectedSiteId'];
          this.selectedMerchantType =
            userInfo.attributes?.['custom:selectedMerchantType'];
          this.store.dispatch(ProductSearchActions.searchProducts.trigger());
          this.store.dispatch(
            OrderListActions.loadOrderList.trigger({
              filter: { page: 0, size: 9999 },
            })
          );
        }
      });
  }

  ngAfterViewInit(): void {
    this.subs.sink = this.store
      .select(ProductSearchSelectors.selectSearchValue)
      .subscribe((value) => {
        this.paginator.pageIndex = value.page;
      });
  }

  trackResult(index: number, result: ProductSearchResponseWithAmount) {
    return result.orderListId;
  }

  pageChanged(pageEvent: PageEvent) {
    this.store.dispatch(
      ProductSearchActions.updateSearchValue.trigger({
        filter: { page: pageEvent.pageIndex, size: pageEvent.pageSize },
      })
    );
    this.store.dispatch(ProductSearchActions.searchProducts.trigger());
    window.scrollTo(0, 0);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.store.dispatch(OrderListActions.reset());
  }
}
